var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.202789,
    y: 0.763916,
    width: 68.5548,
    height: 68.5548,
    rx: 9.79354,
    fill: "#FFF0EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6122 16.3809C17.5988 16.5082 16.5004 17.007 15.7363 17.6915C15.0731 18.2911 14.5 19.2143 14.2294 20.127C14.0437 20.7584 13.9906 21.9258 14.1233 22.5784C14.5265 24.5576 15.9645 26.1176 17.8747 26.6482C18.5486 26.8339 19.5673 26.8817 20.2094 26.7543C22.2416 26.3458 23.8229 24.8866 24.3482 22.9286C24.5127 22.329 24.5445 21.2147 24.4224 20.6098C24.1996 19.5168 23.7592 18.6731 22.9951 17.8984C21.849 16.7417 20.2253 16.1739 18.6122 16.3809ZM21.8437 18.8429C22.0082 18.9278 22.0612 19.018 22.0612 19.2302C22.0612 19.3417 21.8914 19.5433 21.26 20.1747L20.4535 20.9813L20.5171 21.1511C20.6869 21.6445 20.5118 22.2441 20.098 22.5943C19.4559 23.1462 18.4318 22.918 18.0763 22.138C17.9278 21.8143 17.9437 21.3209 18.1082 20.9972C18.3894 20.44 18.9996 20.1588 19.6045 20.318L19.8804 20.3923L20.6392 19.6282C21.3184 18.9384 21.5094 18.7792 21.6527 18.7686C21.6739 18.7633 21.7641 18.8004 21.8437 18.8429Z",
    fill: "#ED5E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1878 38.1198V48.5835L19.2649 48.5729L20.3367 48.557L20.3527 38.1039L20.3633 27.6508H19.2755H18.1878V38.1198Z",
    fill: "#ED5E2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.98 29.89C26.9588 29.9059 26.9429 34.1243 26.9429 39.2553V48.5835H37.7143H48.4857L48.4751 39.2288L48.4592 29.8794H44.4531H40.4469L40.431 32.8615L40.4204 35.8488H37.7408H35.0612V32.8827C35.0612 30.2296 35.0506 29.9166 34.9763 29.8847C34.8649 29.8423 27.0224 29.8423 26.98 29.89Z",
    fill: "#ED5E2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5878 50.4672V51.5549H34.7694H53.951V50.4672V49.3794H34.7694H15.5878V50.4672Z",
    fill: "#ED5E2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9657 53.0248L21.9816 53.651L24.2261 53.6669L26.4653 53.6775V53.0408V52.404H24.2102H21.9498L21.9657 53.0248Z",
    fill: "#ED5E2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0735 53.0408V53.6775H45.3286H47.5837V53.0408V52.404H45.3286H43.0735V53.0408Z",
    fill: "#ED5E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialOrange);
export default __webpack_public_path__ + "static/media/material_orange.4656b220c596db7a5c5c452a6fd51c47.svg";
export { ForwardRef as ReactComponent };